var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider slider2 "},[_c('div',{staticClass:"title"}),_vm._v(" "),_c('div',{staticClass:"cnt"},[_c('div',{staticClass:"position-relative w100 h100"},[_c('div',{staticClass:"reg"},[_c('regLogin',{attrs:{"isEventPageLogin":false,"box2Login":_vm.box2Login},on:{"handleInfoAgain":_vm.handleInfoAgain}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9783a5ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/publicComponents/slider2.vue
// module id = null
// module chunks = 